import type { IconData } from '@stacksjs/iconify-core'

export const computersDevicesElectronicsKeyboardPad: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.19 6.1h1.52v24.38h-1.52ZM3.81 30.48h24.38V32H3.81Zm9.14-7.62v6.1h13.72v-6.1Zm12.19 3.05h-1.52v1.52h-3.05v-1.52h-1.52v-1.53h1.52v1.53h3.05v-1.53h1.52Zm-4.57-10.67v6.1h6.1v-6.1Zm4.57 4.57h-3.05v-3.04h3.05ZM20.57 7.62v6.1h6.1v-6.1Zm4.57 4.57h-3.05V9.15h3.05ZM12.95 1.53h9.14v1.52h-9.14Zm6.1 19.81v-6.1h-6.1v6.1Zm-4.57-4.57h3.04v3.04h-3.04Zm4.57-3.05v-6.1h-6.1v6.1Zm-4.57-4.57h3.04v3.04h-3.04ZM11.43 0h1.52v1.53h-1.52Zm-6.1 22.86v6.1h6.1v-6.1Zm4.57 4.57H6.86v-3.05H9.9ZM5.33 15.24v6.1h6.1v-6.1Zm4.57 4.57H6.86v-3.04H9.9ZM5.33 7.62v6.1h6.1v-6.1Zm4.57 4.57H6.86V9.15H9.9ZM28.19 6.1V4.58h-4.57V3.05h-1.53v1.53H3.81V6.1zm-25.9 0h1.52v24.38H2.29Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computersDevicesElectronicsKeyboardPad
